import { render, staticRenderFns } from "./CommunityCard.vue?vue&type=template&id=726ccb20&scoped=true&"
import script from "./CommunityCard.vue?vue&type=script&lang=js&"
export * from "./CommunityCard.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCard.vue?vue&type=style&index=0&id=726ccb20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726ccb20",
  null
  
)

export default component.exports